import React, { useState, useEffect } from 'react';
import "./MedicalEventReportForm.css";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import FormSubmit from '../../../../../services/form/formSubmit';

const MedicalEventReportForm = () => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const eventId = params.eventId;

    // ✅ Initialize state with an empty object to prevent undefined errors
    const [formData, setFormData] = useState({});

    const fetchFormData = async (id) => {
        try {
            const response = await FormSubmit.getAllEventReportById(id);
            console.log("Fetched Form Data:", response);
    
            if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
                setFormData(response.data[0]); // ✅ Extract the first object
            } else {
                console.warn("No form data found!");
                setFormData({}); // Fallback to an empty object
            }
        } catch (error) {
            console.error("Error fetching forms:", error);
        }
    };    

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem("userinfo"));
        setTimeout(() => {
            if (user && user.roleLabel.toLowerCase() === "superadmin") {
                fetchFormData(eventId);
            } else {
                fetchFormData(eventId);
                // localStorage.setItem("redirectRoute", location.pathname);
                // navigate('/');
            }
        }, 200);
    }, [eventId]); // ✅ Added dependency to re-fetch if eventId changes

    // ✅ Debugging: Check if state updates correctly
    useEffect(() => {
        console.log("Updated Form Data:", formData);
    }, [formData]); // Logs formData every time it updates
          

    return (
        <div className='form-container'>
            <h2 className='heading'>MEDICAL EVENT REPORT FORM</h2>
            <div className='orgName'>
                <h5>NAME OF AIRLINE</h5>
                <div className='orgInputBox'>
                    <p className='paragraphFontStyle'>Completed form to be retured to: </p>
                    <input className='orgInput inputFontStyle' type='text' value={formData.orgId || "Missing"} />
                </div>
            </div>

            <div className='meReport'>
                <h4>MEDICAL EVENT REPORT</h4>
                <p className='paragraphFontStyle'>(To be completed for all incident)</p>
                <div className='meReportInputBox'>
                    <label className='submitterName'> Name of person completing form</label>
                    <input className='inputFontStyle submitterNameInput' type="text" value={formData.personCompletingFormName || ""} />
                    <label className='staffIdLabel'>Staff ID:</label>
                    <input className='inputFontStyle staffIdInputBox' type="text" value={formData.staffId || ""} />
                </div>
            </div>
            <h5 style={{ textAlign: 'center', marginTop: "10px" }}>SECTION 1:</h5>
            <div className='meReport' >
                <div className="inline_block" style={{ width: "25%", marginLeft: "-32px" }}>
                    <label className='inputLabel' >Date</label>
                    <input className='inputBox inputFontStyle' type="text" value={formData.createdAt || ""} />
                </div>
                <div className="inline_block" style={{ width: "23%" }}>
                    <label className='inputLabel' >Flight No:</label>
                    <input style={{ width: "60%" }} className='inputBox inputFontStyle' type="text" value={formData?.flightNumber || ""} />
                </div>
                <div className="inline_block" style={{ width: "25%" }}>
                    <label className='inputLabel' >From:</label>
                    <input className='inputBox inputFontStyle' type="text" value={formData?.fromLocation || ""} />
                </div>
                <div className="inline_block" style={{ width: "25%" }}>
                    <label className='inputLabel' >To:</label>
                    <input className='inputBox inputFontStyle' style={{ width: "61%" }} type="text" value={formData.toLocation || ""}/>
                </div>
            </div>

            <h5 style={{ marginTop: '10px', display: "inline-block" }}>PATIENT DETAILS</h5>
            <p className='paragraphFontStyle' style={{ marginTop: "10px", display: "inline-block" }}>(Complete as applicable)</p>
            <div className='patientDetails'>
                <div style={{ width: "100%", marginLeft: "11px" }}>
                    <label style={{ display: 'inline-block', width: "12%" }} >Name:</label>
                    <input className='inputFontStyle' style={{ width: "82%", padding: "10px" }} type="text" value={formData?.patientName || "Missing"} />
                </div>
                <div style={{ marginTop: "10px" }} >
                    <div className="inline_block" style={{ width: "15%" }}>
                        <label className='inputLabel' >Sex</label>
                        <input className='inputBox inputFontStyle' style={{ width: "40%" }} type="text" value={formData?.gender || "Missing"} />
                    </div>
                    <div className="inline_block" style={{ width: "30%" }}>
                        <label className='inputLabel' style={{ display: "inline-block", width: "40%" }} >Date of Birth:</label>
                        <input style={{ width: "42%" }} className='inputBox inputFontStyle' type="text" value={formData?.dateOfBirth || "Missing"} />
                    </div>
                    <div className="inline_block" style={{ width: "20%" }}>
                        <label className='inputLabel' >Seat No:</label>
                        <input className='inputBox inputFontStyle' style={{ width: "37%" }} type="text" value={formData?.seatNumber || "Missing"} />
                    </div>
                    <div className="inline_block" style={{ width: "33%" }}>
                        <label className='inputLabel' >Frequent flyer member:</label>
                        <input className='inputBox inputFontStyle' style={{ width: '37%' }} type="text" value={formData?.frequentFlyerNumber || "Missing"} />
                    </div>
                </div>
                <div style={{ width: "100%", marginLeft: "11px", marginTop: "10px" }}>
                    <label style={{ display: 'inline-block', width: "12%" }} >Home Address:</label>
                    <input className='inputFontStyle' style={{ width: "82%", padding: "10px" }} type="text" value={formData?.homeAddress || "Missing"} />
                </div>
            </div>

            <h5 style={{ marginTop: '10px', display: "inline-block" }}>DETAILS OF ILLNESS / ACCIDENT </h5>
            <div className='accidentDetails'>
                <div style={{display:"flex"}}>
                    <div style={{width:"50%"}}>
                        <label style={{marginRight:"5px"}}>Time/Date of Onset (GMT):</label>
                        <input className='inputFontStyle' style={{padding:"10px",width:"50%"}} type="text" value={formData?.timeOfOnsetGMT || "Missing"} />
                    </div>
                    <div style={{width:"50%"}}>
                        <label style={{marginRight:"5px"}}>Location:</label>
                        <input className='inputFontStyle' style={{padding:'10px',width:"75%"}} type="text" value={formData?.location || "Missing"} />
                    </div>
                </div>
                <div style={{display: "flex", marginTop: "20px"}}>
                    <label style={{marginRight:"10px"}}> Describe events leading up to incident: </label>
                    <textarea id="incident-description" placeholder="Describe events leading up to the incident:" value={formData?.descriptionOfEventsLeadingToIncident || "Missing"} style={{width: "67%", height: "60px", paddingLeft:"10px"}}></textarea>
                </div>
            </div>

            <h5 style={{ marginTop: '10px', display: "inline-block" }}>SYMPTOMS & SIGNS</h5>
            <p className='paragraphFontStyle' style={{ marginTop: "10px", display: "inline-block" }}>(tick, circle or complete all appropriate boxes)</p>
            <div className='symptomsSigns'>
                <div style={{display: "flex", justifyContent: "center", flexDirection:"column"}}>
                    <div style={{width: "100%", display: "flex"}}>
                        <div style={{width: "8%", height: "80px"}}>
                            <label>Pain:</label>
                        </div>
                        <div style={{width: "100%"}}>
                            <div style={{width: "100%", display: "flex"}}>
                                <div style={{width: "50%", display: "flex"}}>
                                    <label style={{width:"20%"}}>Site(s):</label>
                                    <input type='text' value={formData?.painSite || "Missing"} style={{width: "70%", height:"40px", paddingLeft:"10px"}}/>
                                </div>
                                <div style={{width: "50%", display: "flex"}}>
                                    <label style={{width:"20%"}}>Severity:</label>
                                    <input type='text' value={formData?.painSeverity || "Missing"} style={{width: "70%", height:"40px", paddingLeft:"10px"}}/>
                                </div>
                            </div>
                            <div style={{width: "100%", display: "flex", marginTop: "10px"}}>
                                <div style={{width: "50%", display: "flex"}}>
                                    <label style={{width:"20%"}}>Character:</label>
                                    <input type='text' value={formData?.painCharacter || "Missing"} style={{width: "70%" , height:"40px", paddingLeft:"10px"}}/>
                                </div>
                                <div style={{width: "50%", display: "flex"}}>
                                    <label style={{width:"20%"}}>Pattern:</label>
                                    <input type='text' value={formData?.painPattern || "Missing"} style={{width: "70%", height:"40px", paddingLeft:"10px"}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{display: "flex", marginTop: "10px"}}>
                        <label style={{margin: "0px 10px 0 0"}}>Bleeding:</label>
                        <div style={{width: "100%"}}>
                            <div style={{width: "100%", display: "flex"}}>
                                <div style={{width: "50%", display: "flex"}}>
                                    <label style={{width:"20%"}}>Site(s):</label>
                                    <input type='text' value={formData?.bleedingSite || ""} style={{width: "70%", height:"40px", paddingLeft:"10px"}}/>
                                </div>
                                <div style={{width: "50%", display: "flex"}}>
                                    <label style={{width:"20%"}}>Severity:</label>
                                    <input type='text' value={formData?.bleedingSeverity || ""} style={{width: "70%", height:"40px", paddingLeft:"10px"}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='form-checkBox'>
                <div className='checkbox-row'>
                    <div className='checkbox-text'>
                        <label htmlFor="nausea-checkbox" style={{ paddingRight: "20px" }}>
                            Nausea
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.nausea} readOnly />
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Vomiting  
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.vomiting} readOnly />
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Diarrhoea 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.diarrhoea} readOnly />
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Cough 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.cough} readOnly />
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Breathless or wheezy 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.breathlessOrWheezy} readOnly/>
                    </div>
                </div>
                <div className='checkbox-row'>
                <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Faint 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.faint} readOnly/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Pale 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.pale} readOnly/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Blue 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.blue} readOnly/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Flushed 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.flushed} readOnly />
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Clammy / Sweating
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.clammyOrSweating} readOnly/>
                    </div>
                </div>
                <div className='checkbox-row'>
                <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Hot / feverish 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.hotOrFeverish} readOnly/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Cold  
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.cold} readOnly/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Dizzy 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.dizzy} readOnly/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Weakness 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.weakness} readOnly />
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Fit / Convulsion
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.fitOrConvulsion} readOnly/>
                    </div>
                </div>
                <div className='checkbox-row'>
                <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Anxious 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.anxious}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Confused  
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.confused}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Aggressive 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.aggressive}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Intoxicated 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.intoxicated}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            
                        </label>
                            <input type="checkbox" id="accept-terms"/>
                    </div>
                </div>
                <div className='checkbox-row'>
                    <div className='checkbox-input'>
                        <label style={{width:"15%"}}> Rash / spots </label>
                        <input type='text' placeholder='Where' value={formData.rashOrSpotsWhere || ""} style={{width:"90%", height: "40px"}}/>
                    </div>
                </div>
                <div className='checkbox-row'>
                    <div className='checkbox-input'>
                        <label style={{width:"15%"}}> Other (specify) </label>
                        <input type='text' value={formData.otherSpecify || ""} style={{width:"90%", height: "40px"}}/>
                    </div>
                </div>
            </div>

            <h5 style={{ marginTop: '10px', display: "inline-block" }}>INJURY </h5>
            <p className='paragraphFontStyle' style={{ marginTop: "10px", display: "inline-block" }}> (tick appropriate box / boxes):</p>
            <div className='form-checkBox'>
                <div className='checkbox-row'>
                        <div className='checkbox-text'>
                            <label for="accept-terms" style={{paddingRight: "20px"}}>
                                Abrasion 
                            </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.abrasion}/>
                        </div>
                        <div className='checkbox-text'>
                            <label for="accept-terms" style={{paddingRight: "20px"}}>
                                Amputation  
                            </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.amputation}/>
                        </div>
                        <div className='checkbox-text'>
                            <label for="accept-terms" style={{paddingRight: "20px"}}>
                                Fracture 
                            </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.fracture} />
                        </div>
                        <div className='checkbox-text'>
                            <label for="accept-terms" style={{paddingRight: "20px"}}>
                                Bruising 
                            </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.bruising}/>
                        </div>
                        <div className='checkbox-text'>
                            <label for="accept-terms" style={{paddingRight: "20px"}}>
                                Burn 
                            </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.burn}/>
                        </div>
                </div>
                <div className='checkbox-row'>
                <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Concussion 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.concussion}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Cut 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.cut}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Dislocation 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.dislocation}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Sprain 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.sprain}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Foreign Body 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.foreignBody}/>
                    </div>
                </div>
            </div>
            <h5 style={{backgroundColor:"#FFF", width:"100%", marginTop:"10px"}}>Body Parts</h5>
            <div className='form-checkBox'>
                <div className='checkbox-row'>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Head / neck 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.headNeckInjury}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Eye  
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.eyeInjury}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Ear 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.earInjury}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Torso 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.torsoInjury}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Back 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.backInjury}/>
                    </div>
                </div>
                <div className='checkbox-row'>
                <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Arm 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.armInjury}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Hand 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.handInjury}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Finger 
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.fingerInjury}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Leg  
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.legInjury}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Foot / toe
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.footToeInjury}/>
                    </div>
                </div>
            </div>

            <div className='observation'>
                <h5 style={{margin:"5px 20px 0 0"}}>OBSERVATIONS: </h5>
                <div className='observation-column'>
                    <div className='observation-input'>
                        <label className='observation-label'>Pulse: </label>
                        <input type='text' id='observation-inputs' value={formData.pulse || ""}/><h5 style={{margin:"5px 0 0 3px"}}>/ minute</h5>
                    </div>
                    <div className='observation-input'>
                        <label className='observation-label'>Temperature: </label>
                        <input type='text' id='observation-inputs' value={formData.temperature || ""}/>
                    </div>
                    <div className='observation-input'>
                        <label className='observation-label'>Other observations: </label>
                        <input type='text' id='observation-inputs' value={formData.otherObservations || ""} style={{width:"70%"}}/>
                    </div>
                </div>
                <div className='observation-column'>
                    <div className='observation-input'>
                        <label className='observation-label'>Blood Pressure: </label>
                        <input type='text' id='observation-inputs' value={`${formData?.bloodPressureDiastolic || ""} - ${formData?.bloodPressureSystolic || ""} `}/> <h5 style={{margin:"5px 0 0 3px"}}>mm / Hg</h5>
                    </div>
                    <div className='observation-input'>
                        <label className='observation-label'>Respiration: </label>
                        <input type='text' id='observation-inputs'value={formData.respirationRate || ""}/><h5 style={{margin:"5px 0 0 3px"}}>/ minute</h5>
                    </div>
                </div>
            </div>
                

            <h5 style={{ marginTop: '10px', display: "inline-block" }}>PATIENT'S MEDICAL HISTORY </h5>
            <div className='patient-medical-history'>
                <div className='patient-medical-history-heading'>
                    <h5> </h5>
                    <h5>DETAIL 5 </h5>
                </div>
                <div className='patient-medical-history-report'>
                    <div className='patient-medical-history-report-form'>
                        <div className='patient-medical-history-report-form-text'>
                            <label> Had this problem before? </label>
                            <div>
                                <input type="radio" id="problem-yes" name="hadThisProblemBefore" value="yes" checked={formData?.hadThisProblemBefore === true} readOnly/>
                                <label className="patient" htmlFor="problem-yes"> YES </label>
                                
                                <input type="radio" id="problem-no" name="hadThisProblemBefore" value="no" checked={formData?.hadThisProblemBefore === false} readOnly/>
                                <label className="patient" htmlFor="problem-no"> NO </label>
                            </div>
                        </div>
                        <input type="text" className='patient-medical-history-report-form-input' value={formData?.problemBeforeDetails || ""} readOnly/>
                    </div>

                    <div className='patient-medical-history-report-form'>
                        <div className='patient-medical-history-report-form-text'>
                            <label> Taking any medication? </label>
                            <div>
                                <input type="radio" id="medication-yes" name="takingMedication" value="yes" checked={formData?.takingMedication === true} readOnly/>
                                <label className="patient" htmlFor="medication-yes"> YES </label>
                                
                                <input type="radio" id="medication-no" name="takingMedication" value="no" checked={formData?.takingMedication === false} readOnly/>
                                <label className="patient" htmlFor="medication-no"> NO </label>
                            </div>
                        </div>
                        <input type="text" className='patient-medical-history-report-form-input' value={formData?.medicationDetails || ""} readOnly/>
                    </div>

                    <div className='patient-medical-history-report-form'>
                        <div className='patient-medical-history-report-form-text'>
                            <label> Any allergies? </label>
                            <div>
                                <input type="radio" id="allergy-yes" name="hasAllergies" value="yes" checked={formData?.hasAllergies === true} readOnly/>
                                <label className="patient" htmlFor="allergy-yes"> YES </label>
                                
                                <input type="radio" id="allergy-no" name="hasAllergies" value="no" checked={formData?.hasAllergies === false} readOnly/>
                                <label className="patient" htmlFor="allergy-no"> NO </label>
                            </div>
                        </div>
                        <input type="text" className='patient-medical-history-report-form-input' value={formData?.allergyDetails || ""} readOnly/>
                    </div>

                    <div className='patient-medical-history-report-form'>
                        <div className='patient-medical-history-report-form-text'>
                            <label> Any recent illnesses or operations? </label>
                            <div>
                                <input type="radio" id="illness-yes" name="hadRecentIllnessOrOperation" value="yes" checked={formData?.hadRecentIllnessOrOperation === true} readOnly/>
                                <label className="patient" htmlFor="illness-yes"> YES </label>
                                
                                <input type="radio" id="illness-no" name="hadRecentIllnessOrOperation" value="no" checked={formData?.hadRecentIllnessOrOperation === false} readOnly/>
                                <label className="patient" htmlFor="illness-no"> NO </label>
                            </div>
                        </div>
                        <input type="text" className='patient-medical-history-report-form-input' value={formData?.recentIllnessDetails || ""} readOnly/>
                    </div>

                    <div className='patient-medical-history-report-form'>
                        <div className='patient-medical-history-report-form-text'>
                            <label> Currently pregnant? </label>
                            <div>
                                <input type="radio" id="pregnant-yes" name="pregnant" value="yes" checked={formData?.pregnant === true} readOnly/>
                                <label className="patient" htmlFor="pregnant-yes"> YES </label>
                                
                                <input type="radio" id="pregnant-no" name="pregnant" value="no" checked={formData?.pregnant === false} readOnly/>
                                <label className="patient" htmlFor="pregnant-no"> NO </label>
                            </div>
                        </div>
                        <label>If yes, how many months?</label>
                        <input type="text" className='patient-medical-history-report-form-input' value={formData?.pregnancyMonths || ""} style={{width: "40%"}} readOnly/>
                    </div>
                </div>

            </div>

            <h5 style={{ marginTop: '10px', display: "inline-block" }}>CABIN CREW ACTION </h5>
            <p className='paragraphFontStyle' style={{ marginTop: "10px", display: "inline-block" }}> (circle or complete as indicated) </p>
            <div className='cca-section'>
                <div className='cca-row'>
                    <div className='cca-inputs'>
                        <label>Oxygen given?</label>
                        <div>
                            <input type="radio" id="oxygen-yes" name="oxygen" value="yes" checked={formData?.oxygenGiven === true}/>
                            <label className="cca-radio" for="oxygen-yes">YES</label>
                            
                            <input type="radio" id="oxygen-no" name="oxygen" value="no" checked={formData?.oxygenGiven === false}/>
                            <label className="cca-radio" for="oxygen-no">NO</label>
                        </div>
                    </div>
                    <div className='cca-inputs' style={{marginLeft: "50px"}}>
                        <label>If yes, did patient’s condition improve?</label>
                        <div>
                            <input type="radio" id="oxygen-yes" name="improveOxygen" value="yes" checked={formData?.patientImprovementAfterOxygen === true} />
                            <label className="cca-radio" for="oxygen-yes">YES</label>
                            
                            <input type="radio" id="oxygen-no" name="oxygen" value="no" checked={formData?.patientImprovementAfterOxygen === false}/>
                            <label className="cca-radio" for="oxygen-no">NO</label>
                        </div>
                    </div>
                </div>
                <div className='cca-row'>
                    <label className='cca-row-label'>Medication given? (specify) </label>
                    <input className="cca-inputs" type='text' style={{width:"70%"}} value={formData?.medicationGiven || ""}/>
                </div>
                <div className='cca-row'>
                    <label className='cca-row-label' >Was own medication or from other passenger used? (specify) </label>
                    <input className="cca-inputs" type='text' style={{width:"70%"}} value={formData?.whoseMedicineUsed || ""}/>
                </div>
                <div className='cca-row' >
                    <div className='cca-inputs'>
                        <label>Defibrillator used?</label>
                        <div>
                            <input type="radio" id="defibrillator-yes" name="defibrillator" value="yes" checked={formData?.defibrillatorUsed === true}/>
                            <label className="cca-radio" for="defibrillator-yes">YES</label>
                            
                            <input type="radio" id="defibrillator-no" name="defibrillator" value="no" checked={formData?.defibrillatorUsed === false} />
                            <label className="cca-radio" for="defibrillator">NO</label>
                        </div>
                    </div>
                    <div className='cca-inputs' style={{marginLeft: "50px"}}>
                        <label> If yes, were any shocks administered?</label>
                        <div>
                            <input type="radio" id="shocksAdministered-yes" name="shocksAdministered" value="yes" checked={formData?.shocksAdministered === true}/>
                            <label className="cca-radio" for="shocksAdministered">YES</label>
                            
                            <input type="radio" id="shocksAdministered-no" name="shocksAdministered" value="no" checked={formData?.shocksAdministered === false}/>
                            <label className="cca-radio" for="shocksAdministered-no">NO</label>
                        </div>
                    </div>
                </div>
                <div className='cca-row'>
                    <label className='cca-row-label' >Other onboard medical equipment used (specify) </label>
                    <input className="cca-inputs" type='text' style={{width:"70%"}} value={formData?.onboardMedicalEquipmentUsed || ""}/>
                </div>
                <div className='cca-row'>
                    <div className='cca-inputs'>
                        <label>Was Cardiopulmonary Resuscitation (CPR) performed?</label>
                        <div style={{width:"140px"}}>
                            <input type="radio" id="cprPerformed-yes" name="cprPerformed	" value="yes" checked={formData?.cprPerformed === true}/>
                            <label className="cca-radio" for="cprPerformed-yes">YES</label>
                            
                            <input type="radio" id="cprPerformed-no" name="cprPerformed" value="no" checked={formData?.cprPerformed === false}/>
                            <label className="cca-radio" for="cprPerformed-no">NO</label>
                        </div>
                    </div>
                    <div className='cca-multiple-inputs'>
                        <div className='cca-multiple-input' style={{marginLeft: "20px"}}>
                            <label>Pulse restored?</label>
                            <div>
                                <input type="radio" id="pulseRestored-yes" name="pulseRestored" value="yes" checked={formData?.pulseRestored === true}/>
                                <label className="cca-radio" for="oxygen-yes">YES</label>
                                
                                <input type="radio" id="pulseRestored-no" name="pulseRestored" value="no" checked={formData?.pulseRestored === false}/>
                                <label className="cca-radio" for="pulseRestored-no">NO</label>
                            </div>
                        </div>
                        <div className='cca-multiple-input' style={{marginLeft: "20px"}}>
                            <label>Respiration restored?</label>
                            <div>
                                <input type="radio" id="respirationRestored-yes" name="respirationRestored" value="yes" checked={formData?.respirationRestored === true} />
                                <label className="cca-radio" for="respirationRestored-yes">YES</label>
                                
                                <input type="radio" id="respirationRestored-no" name="respirationRestored" value="no" checked={formData?.respirationRestored === false}/>
                                <label className="cca-radio" for="respirationRestored-no">NO</label>
                            </div>
                        </div>
                        <div className='cca-multiple-input' style={{marginLeft: "20px"}}>
                            <label>Consciousness regained?</label>
                            <div>
                                <input type="radio" id="consciousnessRegained-yes" name="consciousnessRegained" value="yes" checked={formData?.consciousnessRegained === true}/>
                                <label className="cca-radio" for="consciousnessRegained-yes">YES</label>
                                
                                <input type="radio" id="consciousnessRegained-no" name="consciousnessRegained" value="no" checked={formData?.consciousnessRegained === false}/>
                                <label className="cca-radio" for="consciousnessRegained-no">NO</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-inputs'>
                        <label>Use of ground medical control</label>
                        <div style={{width:"140px", textAlign:"end"}}>
                            <input type="radio" id="useOfGroundMedicalControl-yes" name="useOfGroundMedicalControl" value="yes" checked={formData?.useOfGroundMedicalControl === true}/>
                            <label className="cca-radio" for="useOfGroundMedicalControl-yes">YES</label>
                            
                            <input type="radio" id="useOfGroundMedicalControl-no" name="useOfGroundMedicalControl" value="no" checked={formData?.useOfGroundMedicalControl === false}/>
                            <label className="cca-radio" for="useOfGroundMedicalControl-no">NO</label>
                        </div>
                    </div>
                    <div className='cca-multiple-inputs'>
                        <div className='cca-multiple-input' style={{marginLeft: "20px"}}>
                            {/* <label>Pulse restored?</label> */}
                            <div>
                                <input type="radio" id="useOfGroundMedicalControlDetails-yes" name="useOfGroundMedicalControlDetails" value="yes" checked={formData?.useOfGroundMedicalControlDetails === 'Successful'}/>
                                <label className="cca-radio" for="useOfGroundMedicalControlDetails-yes">Successful</label>
                                
                                <input type="radio" id="useOfGroundMedicalControlDetails-no" name="useOfGroundMedicalControlDetails" value="no" checked={formData?.useOfGroundMedicalControlDetails === 'Unsuccessful'}/>
                                <label className="cca-radio" for="useOfGroundMedicalControlDetails-no">unsuccessful </label>
                            </div>
                        </div>
                        <div className='cca-multiple-input' style={{marginLeft: "20px"}}>
                            <div>
                            <label style={{marginRight:"5px"}}>Comms use</label>
                                <input type="radio" id="oxygen-yes" name="oxygen" value="yes" checked={formData?.groudMedicalControlUseComms === "SATCOM"}/>
                                <label className="cca-radio" for="oxygen-yes">SATCOM </label>
                                
                                <input type="radio" id="oxygen-no" name="oxygen" value="no" checked={formData?.groudMedicalControlUseComms === "HF"}/>
                                <label className="cca-radio" for="oxygen-no">HF </label>

                                <input type="radio" id="oxygen-no" name="oxygen" value="no" checked={formData?.groudMedicalControlUseComms === "ACARS"}/>
                                <label className="cca-radio" for="oxygen-no">ACARS  </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-inputs'>
                        <label>Assistance of on-board Dr. or Health Professional</label>
                        <div style={{width:"140px", textAlign:"end"}}>
                            <input type="radio" id="contactedOnboardDoctor-yes" name="contactedOnboardDoctor" value="yes" checked={formData?.contactedOnboardDoctor === true}/>
                            <label className="cca-radio" for="contactedOnboardDoctor-yes">YES</label>
                            
                            <input type="radio" id="contactedOnboardDoctor-no" name="contactedOnboardDoctor" value="no" checked={formData?.contactedOnboardDoctor === false}/>
                            <label className="cca-radio" for="contactedOnboardDoctor-no">NO</label>
                        </div>
                    </div>
                    <div className='cca-multiple-inputs'>
                        <div className='cca-multiple-input' style={{marginLeft: "20px"}}>
                            <div>
                                <input type="radio" id="contactedOnboardDoctorDetails-yes" name="contactedOnboardDoctorDetails" value="yes" checked={formData?.contactedOnboardDoctorDetails === 'Successful'}/>
                                <label className="cca-radio" for="contactedOnboardDoctorDetails-yes">Successful</label>
                                
                                <input type="radio" id="contactedOnboardDoctorDetails-no" name="contactedOnboardDoctorDetails" value="no" checked={formData?.contactedOnboardDoctorDetails === 'Unsuccessful'}/>
                                <label className="cca-radio" for="contactedOnboardDoctorDetails-no">unsuccessful </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-inputs'>
                        <label>Attempt to contact company doctor:</label>
                        <div style={{width:"140px", textAlign:"end"}}>
                            <input type="radio" id="attemptToContactCompanyDoctor-yes" name="attemptToContactCompanyDoctor" value="yes" checked={formData?.attemptToContactCompanyDoctor === true}/>
                            <label className="cca-radio" for="attemptToContactCompanyDoctor-yes">YES</label>
                            
                            <input type="radio" id="attemptToContactCompanyDoctor-no" name="attemptToContactCompanyDoctor" value="no" checked={formData?.attemptToContactCompanyDoctor === false}/>
                            <label className="cca-radio" for="attemptToContactCompanyDoctor-no">NO</label>
                        </div>
                    </div>
                    <div className='cca-multiple-inputs'>
                        <div className='cca-multiple-input' style={{marginLeft: "20px"}}>
                            {/* <label>Pulse restored?</label> */}
                            <div>
                                <input type="radio" id="contactedCompanyDoctorDetails-yes" name="contactedCompanyDoctorDetails" value="yes" checked={formData?.contactedCompanyDoctorDetails === "Successful"}/>
                                <label className="cca-radio" for="contactedCompanyDoctorDetails-yes">Successful</label>
                                
                                <input type="radio" id="contactedCompanyDoctorDetails-no" name="contactedCompanyDoctorDetails" value="no" checked={formData?.contactedCompanyDoctorDetails === "Unsuccessful"}/>
                                <label className="cca-radio" for="contactedCompanyDoctorDetails-no">unsuccessful </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-inputs'>
                        <label>Port Health Authority advised:</label>
                        <div style={{width:"140px", textAlign:"end"}}>
                            <input type="radio" id="contactedPortHealthAuthority-yes" name="contactedPortHealthAuthority" value="yes" checked={formData?.contactedPortHealthAuthority === true}/>
                            <label className="cca-radio" for="contactedPortHealthAuthority-yes">YES</label>
                            
                            <input type="radio" id="contactedPortHealthAuthority-no" name="contactedPortHealthAuthority" value="no" checked={formData?.contactedPortHealthAuthority === false} />
                            <label className="cca-radio" for="contactedPortHealthAuthority-no">NO</label>
                        </div>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-textarea'>
                        <label>Further information / comments: </label>
                        <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.cabinCrewComments || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                    </div>
                </div>
            </div>

            <h5 style={{ marginTop: '10px', display: "inline-block" }}>OUTCOME </h5>
            <p className='paragraphFontStyle' style={{ marginTop: "10px", display: "inline-block" }}>(tick)</p>
            <div className='form-checkBox'>
                <div className='checkbox-row'>
                    <label style={{width: "5%"}}> </label>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"40%"}}>
                            Diversion  
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.diversion}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"80%"}}>
                            Patient recovered before landing  
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.patientRecoveredBeforeLanding}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"80%"}}>
                            Patient walked off aided / unaided 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.patientWalkedOffAidedUnaided}/>
                    </div>
                </div>
                <div className='checkbox-row'>
                <label style={{width: "5%"}}> </label>
                <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"80%"}}>
                            Patient left aircraft by wheelchair 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.patientLeftAircraftByWheelchair}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"80%"}}>
                            Patient left aircraft by stretcher 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.patientLeftAircraftByStretcher}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"80%"}}>
                            Patient died on aircraft  
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.patientDiedOnAircraft}/>
                    </div>
                </div>
                <div className='checkbox-row' style={{marginTop:"30px"}}>
                    <h5 style={{marginTop:"5px", width:"10%"}}>Treatment:</h5>
                <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            None
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.treatmentProvidedNone}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            First Aid   
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.treatmentFirstAid}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Ground medical  
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.treatmentGroundMedical} />
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            GP / Appointed Dr
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.treatmentProvidedGP}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px"}}>
                            Hospital 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.treatmentProvidedHospital} />
                    </div>
                </div>
                <div className='checkbox-row' style={{marginTop:"15px"}}>
                    <h5 style={{width: "5%"}}>Crew:</h5>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"40%"}}>
                            Fit to operate  
                        </label>
                        <input type="checkbox" id="accept-terms" checked={!!formData?.diversion}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"80%"}}>
                            Fit to fly as passenger
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.patientRecoveredBeforeLanding}/>
                    </div>
                    <div className='checkbox-text'>
                        <label for="accept-terms" style={{paddingRight: "20px", width:"80%"}}>
                            Remained in hotel / hospital 
                        </label>
                            <input type="checkbox" id="accept-terms" checked={!!formData?.patientWalkedOffAidedUnaided}/>
                    </div>
                </div>
            </div>

            <div style={{display:"flex", alignItems: "center"}}>
                <hr style={{flex:"1", border:"2px dotted black"}}></hr>
                <span style={{margin:"0 10px", whiteSpace:"nowrap"}}> Cut-off portion </span>
                <hr style={{flex:"1", border:"2px dotted black"}}></hr>
            </div>


            <div className='cut-off'>
                <h5>Transfer of Care to Ground Medical Services </h5>
                <div style={{display:"flex", marginTop:"10px"}}>
                    <div className='cutt-off-input'>
                        <label>Name of Casualty:</label>
                        <input type='text' className='cutt-off-inputs' value={formData?.casualtyName || ""}/>
                    </div>
                    <div className='cutt-off-input'>
                        <label>Date and time of onset:</label>
                        <input type='text' className='cutt-off-inputs' value={formData?.dateNTimeOfOnset || ""}/>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-textarea'>
                        <label>Brief Details of Incident: </label>
                        <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.briefIncidentDetails || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                    </div>
                </div>
                <div className='cca-row'>
                    <div className='cca-inputs'>
                        <label>Oxygen given?</label>
                        <div>
                            <input type="radio" id="oxygenGivenOnGround-yes" name="oxygenGivenOnGround" value="yes" checked={formData?.oxygenGivenOnGround === true}/>
                            <label className="cca-radio" for="oxygenGivenOnGround-yes">YES</label>
                            
                            <input type="radio" id="oxygenGivenOnGround-no" name="oxygenGivenOnGround" value="no" checked={formData?.oxygenGivenOnGround === false}/>
                            <label className="cca-radio" for="oxygenGivenOnGround-no">NO</label>
                        </div>
                    </div>
                    <div className='cca-inputs' style={{marginLeft: "50px"}}>
                        <label>If yes, did patient’s condition improve?</label>
                        <div>
                            <input type="radio" id="improvementAfterOxy-yes" name="improvementAfterOxy" value="yes" checked={formData?.improvementAfterOxy === true}/>
                            <label className="cca-radio" for="improvementAfterOxy-yes">YES</label>
                            
                            <input type="radio" id="improvementAfterOxy-no" name="improvementAfterOxy" value="no" checked={formData?.improvementAfterOxy === true}/>
                            <label className="cca-radio" for="improvementAfterOxy-no">NO</label>
                        </div>
                    </div>
                </div>
                <div className='cca-row'>
                    <div className='cca-inputs'>
                        <label>Was casualty unconscious at any time?</label>
                        <div>
                            <input type="radio" id="casuallyUnconsciousAtAnyTime-yes" name="casuallyUnconsciousAtAnyTime" value="yes" checked={formData?.casuallyUnconsciousAtAnyTime === true}/>
                            <label className="cca-radio" for="casuallyUnconsciousAtAnyTime-yes">YES</label>
                            
                            <input type="radio" id="casuallyUnconsciousAtAnyTime-no" name="casuallyUnconsciousAtAnyTime" value="no" checked={formData?.casuallyUnconsciousAtAnyTime === false}/>
                            <label className="cca-radio" for="casuallyUnconsciousAtAnyTime-no">NO</label>
                        </div>
                    </div>
                </div>
                <div className='cca-row'>
                    <div className='cca-inputs'>
                        <label>Defibrillator applied?</label>
                        <div>
                            <input type="radio" id="defibrillatorAppliedOnGround-yes" name="defibrillatorAppliedOnGround" value="yes" checked={formData?.defibrillatorAppliedOnGround === true}/>
                            <label className="cca-radio" for="defibrillatorAppliedOnGround-yes">YES</label>
                            
                            <input type="radio" id="defibrillatorAppliedOnGround-no" name="defibrillatorAppliedOnGround" value="no" checked={formData?.defibrillatorAppliedOnGround === false}/>
                            <label className="cca-radio" for="defibrillatorAppliedOnGround-no">NO</label>
                        </div>
                    </div>
                    <div className='cca-inputs' style={{marginLeft: "50px"}}>
                        <label>If yes, were any shocks given?</label>
                        <div>
                            <input type="radio" id="shockesGiven-yes" name="shockesGiven" value="yes" checked={formData?.shockesGiven === true}/>
                            <label className="cca-radio" for="shockesGiven-yes">YES</label>
                            
                            <input type="radio" id="shockesGiven-no" name="shockesGiven" value="no" checked={formData?.shockesGiven === false}/>
                            <label className="cca-radio" for="shockesGiven-no">NO</label>
                        </div>
                    </div>
                </div>
                <div className='textarea-section'>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-textarea'>
                        <label>Medication Administered: </label>
                        <label>Drug: </label>
                        <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.medicationAdministeredDrug || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-textarea'>
                        <label>Dose: </label>
                        <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.medicationDose || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-textarea'>
                        <label>Time (GMT): </label>
                        <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.medicationTime || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                    </div>
                </div>
                </div>
                <div className='textarea-section'>
                    <div className='cca-row' style={{marginTop:"30px"}}>
                        <div className='cca-textarea'>
                            <label>Any other treatment given:  </label>
                            <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.otherTreatmentGiven || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                        </div>
                    </div>
                </div>
                <div className='textarea-section'>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-textarea'>
                        <label>Crew Member name (CAPITALS):  </label>
                        <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.crewMemberName || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-textarea'>
                        <label>Staff Number:  </label>
                        <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.crewStaffNumber || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                    </div>
                </div>
                <div className='cca-row' style={{marginTop:"30px"}}>
                    <div className='cca-textarea'>
                        <label>Signature: </label>
                        <textarea id="incident-description" placeholder="Further information / comments:" value={formData?.crewSignature || ""} style={{width: "100%", height:"100px", marginTop:"10px"}}></textarea>
                    </div>
                </div>
                </div>
                
            </div>

        </div>
    );
}

export default MedicalEventReportForm;
